import Vue from 'vue'

export default {
    UPDATE_TESTIMONIALS (state, value) {
        Vue.set(state, 'testimonials', value);
    },
    SET_TESTIMONIALS (state, value) {
        this.commit('UPDATE_TESTIMONIALS', value);
    },
    SET_SELECTED_TESTIMONIAL (state,  value ) {
      Vue.set(state, 'selectedTestimonial', value);
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/testimonials/mutations.js